import { useState } from "react";
import logo from "./assets/logo.png";
import Layout from "./Layout";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsConditions from "./TermsConditions";
import Disclaimer from "./Disclaimer";

function RoleSelector({ setRole }) {
  const [page, setPage] = useState("home");

  if (page === "about") {
    return <AboutUs goBack={() => setPage("home")} />;
  }

  if (page === "contact") {
    return <ContactUs goBack={() => setPage("home")} />;
  }

  if (page === "privacy") {
    return <PrivacyPolicy goBack={() => setPage("home")} />;
  }

  if (page === "terms") {
    return <TermsConditions goBack={() => setPage("home")} />;
  }

  if (page === "disclaimer") {
    return <Disclaimer goBack={() => setPage("home")} />;
  }

  return (
    <Layout>

      {/* ================= Logo ================= */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%"
        }}
      >
        <img
          src={logo}
          alt="MNHouseFinder"
          style={{
            width: "130px",
            maxWidth: "35%",
            marginBottom: "15px"
          }}
        />

        <h1
          className="page-title"
          style={{
            color: "#ffd600",
            fontSize: "clamp(22px,4vw,34px)",
            textAlign: "center",
            margin: 0,
            lineHeight: "1.2"
          }}
        >
          MNHouseFinder
        </h1>

        <p className="page-subtitle">
          Hustle-free house hunting
        </p>

        <p
          style={{
            color: "white",
            maxWidth: "850px",
            textAlign: "center",
            lineHeight: "1.8",
            marginTop: "25px",
            fontSize: "clamp(16px,2vw,20px)"
          }}
        >
          Welcome to MNHouseFinder, a platform that helps landlords advertise vacant houses 
and connect with potential tenants while helping
     tenants easily find rental houses anywhere in Kenya.
        </p>
      </div>

      {/* ================= Heading ================= */}

      <h2
        style={{
          color: "#ffd600",
          textAlign: "center",
          fontSize: "clamp(26px,3vw,34px)",
          margin: "40px 0 30px"
        }}
      >
        Who are you?
      </h2>

      {/* ================= Cards ================= */}

      <div className="responsive-grid">

        {/* Tenant */}

        <div className="page-card">

          <div style={{ textAlign: "center" }}>

            <div
              style={{
                fontSize: "60px",
                marginBottom: "15px"
              }}
            >
              🏠
            </div>

            <h2
              style={{
                marginBottom: "20px"
              }}
            >
              Tenant
            </h2>

            <p
              style={{
                lineHeight: "1.8",
                marginBottom: "30px"
              }}
            >
              Search houses by town,
              area and house type.
            </p>

            <button
              className="primary-btn"
              onClick={() => setRole("tenant")}
            >
              Enter as Tenant
            </button>

          </div>

        </div>

        {/* Landlord */}

        <div className="page-card">

          <div style={{ textAlign: "center" }}>

            <div
              style={{
                fontSize: "60px",
                marginBottom: "15px"
              }}
            >
              🏢
            </div>

            <h2
              style={{
                marginBottom: "20px"
              }}
            >
              Landlord
            </h2>

            <p
              style={{
                lineHeight: "1.8",
                marginBottom: "30px"
              }}
            >
              Advertise houses and manage rentals.
            </p>

            <button
              className="primary-btn"
              onClick={() => setRole("landlord")}
            >
              Enter as Landlord
            </button>

          </div>

        </div>

      </div>

      {/* Footer starts below */}
      {/* ================= Footer ================= */}

      <div
        style={{
          marginTop: "50px",
          background: "rgba(255,255,255,0.12)",
          borderRadius: "20px",
          padding: "25px"
        }}
      >

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            gap: "12px",
            marginBottom: "20px"
          }}
        >

          <button
            className="primary-btn"
            style={{
              width: "auto",
              padding: "12px 20px"
            }}
            onClick={() => setPage("about")}
          >
            About Us
          </button>

          <button
            className="primary-btn"
            style={{
              width: "auto",
              padding: "12px 20px"
            }}
            onClick={() => setPage("contact")}
          >
            Contact Us
          </button>

          <button
            className="primary-btn"
            style={{
              width: "auto",
              padding: "12px 20px"
            }}
            onClick={() => setPage("privacy")}
          >
            Privacy Policy
          </button>

          <button
            className="primary-btn"
            style={{
              width: "auto",
              padding: "12px 20px"
            }}
            onClick={() => setPage("terms")}
          >
            Terms & Conditions
          </button>

          <button
            className="primary-btn"
            style={{
              width: "auto",
              padding: "12px 20px"
            }}
            onClick={() => setPage("disclaimer")}
          >
            Disclaimer
          </button>

        </div>

        <div
          style={{
            textAlign: "center",
            color: "white",
            lineHeight: "2",
            fontSize: "clamp(15px,2vw,18px)"
          }}
        >

          <p>📍 Sunrise House, Kithimani</p>

          <p>📞 0745 746 190 | 0798 061 862</p>

          <p>📧 supportmnhousefinder@gmail.com</p>

          <p
            style={{
              marginTop: "18px",
              opacity: 0.9
            }}
          >
            © 2026 MNHouseFinder. All Rights Reserved.
          </p>

        </div>

      </div>

    </Layout>
  );
}

export default RoleSelector;